var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BottomSheet',{ref:"tips-sheet",attrs:{"name":"test-sheet"}},[_vm._v(" Like ")])}
var staticRenderFns = []

export { render, staticRenderFns }